import { render, staticRenderFns } from "./costLayout.vue?vue&type=template&id=46c5efee&scoped=true&"
import script from "./costLayout.vue?vue&type=script&lang=js&"
export * from "./costLayout.vue?vue&type=script&lang=js&"
import style0 from "./costLayout.vue?vue&type=style&index=0&id=46c5efee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c5efee",
  null
  
)

export default component.exports